import React, { useContext, useCallback } from 'react';

import { closeActiveTooltip } from '../TooltipBtn';
import { DirtyFormProxyReactContext } from './const';

const withDirtyFormProxyButton = (ButtonComponent) => {
	return (props) => {
		const oldOnClick = props.onClick;
		const disabled = props.disabled;
		const hideConfirmButton = props.hideConfirmButton;
		const { subscriber, hasChanges, activeDirtyFormName, setConfirmationModalOptions } =
			useContext(DirtyFormProxyReactContext);

		const handleOnClick = useCallback(
			(e) => {
				e.persist();
				e.preventDefault();
				if (disabled) return;

				if (hasChanges) {
					setConfirmationModalOptions({
						isOpen: true,
						hasDiscard: hideConfirmButton,
					});
					closeActiveTooltip();

					return subscriber.registerUserAction(activeDirtyFormName, () => oldOnClick(e));
				}

				oldOnClick(e);
			},
			[
				subscriber,
				disabled,
				oldOnClick,
				hasChanges,
				hideConfirmButton,
				activeDirtyFormName,
				setConfirmationModalOptions,
			],
		);

		return (
			<ButtonComponent
				{...props}
				onClick={handleOnClick}
			/>
		);
	};
};

export { withDirtyFormProxyButton };
export default withDirtyFormProxyButton;
